module.exports = __webpack_public_path__ + "img/paint.4c53e984.png";